// Reusable score bar used in both single paper results
// and the batch results table. Color changes based on score value.

import React from 'react';
import shared from '../styles/shared.module.css';

interface ScoreBarProps {
  score: number;
}

function getScoreFillClass(score: number, styles: CSSModuleClasses): string {
  if (score >= 4) return `${styles.scoreFill} ${styles.scoreHigh}`;
  if (score >= 3) return `${styles.scoreFill} ${styles.scoreMid}`;
  return `${styles.scoreFill} ${styles.scoreLow}`;
}

function getScoreValueClass(score: number, styles: CSSModuleClasses): string {
  if (score >= 4) return `${styles.scoreValue} ${styles.scoreHigh}`;
  if (score >= 3) return `${styles.scoreValue} ${styles.scoreMid}`;
  return `${styles.scoreValue} ${styles.scoreLow}`;
}

// CSS modules type
type CSSModuleClasses = { [className: string]: string };

export default function ScoreBar({ score }: ScoreBarProps) {
  const pct = (score / 5) * 100;

  return (
    <div className={shared.scoreBar}>
      <div className={shared.scoreTrack}>
        <div
          className={getScoreFillClass(score, shared)}
          style={{ width: `${pct}%` }}
        />
      </div>
      <span className={getScoreValueClass(score, shared)}>
        {score.toFixed(1)}
      </span>
    </div>
  );
}